<template>
  <v-layout
    class="overflow-visible bottomNav elShowWhenMobile"
    style="height: 56px"
  >
    <v-bottom-navigation v-model="value" color="primary" mode="shift" grow>
      <v-btn>
        <router-link class="menu-btn" to="/home" target="_self">
          <i class="iconfont mdi mdi-home" />
        </router-link>
        <span :class="{ simplifyClass: this.$store.state.isSimplify }"
          >首页</span
        >
      </v-btn>
      <v-btn>
        <router-link class="menu-btn" to="/ai/art" target="_self">
          <i class="iconfont mdi mdi-brush" />
        </router-link>
        <span :class="{ simplifyClass: this.$store.state.isSimplify }"
          >绘画</span
        >
      </v-btn>

      <v-btn>
        <router-link class="menu-btn" to="/ai/chatgpt" target="_self">
          <i class="iconfont mdi mdi-lightbulb" />
        </router-link>
        <span :class="{ simplifyClass: this.$store.state.isSimplify }"
          >问答</span
        >
      </v-btn>

      <v-btn>
        <router-link class="menu-btn" to="/ai/audio" target="_self">
          <i class="iconfont mdi mdi-music-circle" />
        </router-link>
        <span :class="{ simplifyClass: this.$store.state.isSimplify }"
          >音频</span
        >
      </v-btn>
      <v-btn>
        <a @click="openDrawer">
          <i class="iconfont iconhanbao" />
        </a>
        <span :class="{ simplifyClass: this.$store.state.isSimplify }"
          >其他</span
        >
      </v-btn>
    </v-bottom-navigation>
  </v-layout>
</template>

<script>
export default {
  mounted() {},
  data: function() {
    return {
      value: 2,
    };
  },
  methods: {
    openDrawer() {
      this.$store.state.drawer = true;
    },
  },
  computed: {
    avatar() {
      return this.$store.state.avatar;
    },
    blogInfo() {
      return this.$store.state.blogInfo;
    },
  },
};
</script>

<style scoped>
.bottomNav {
  position: fixed;
  z-index: 5;
  width: 100%;
  bottom: 0px;
  height: auto !important;
}
.v-item-group.v-bottom-navigation .v-btn {
  height: 56px !important;
}
</style>
